module.exports = __webpack_public_path__ + "static/robe_of_stars-7874cf01e828e6ad86ab444f64a09a79.jpeg";